import { AxiosInstance } from 'axios'
import { AuthResult, LoginResult } from '/@src/models/auth'

export function login(
  api: AxiosInstance,
  username: String,
  password: String
): Promise<LoginResult> {
  return api.post('/v1/admin/user/login', {
    username: username,
    password: password,
  })
}

export function getSelfInfo(api: AxiosInstance): Promise<AuthResult> {
  return api.get('/v1/admin/user/self')
}
